var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42854 6.1875C7.48389 6.1875 5.89282 7.77857 5.89282 9.72321C5.89282 11.6679 7.48389 13.2589 9.42854 13.2589C11.3732 13.2589 12.9643 11.6679 12.9643 9.72321C12.9643 7.77857 11.3732 6.1875 9.42854 6.1875ZM9.42854 12.0804C8.13211 12.0804 7.07139 11.0196 7.07139 9.72321C7.07139 8.42679 8.13211 7.36607 9.42854 7.36607C10.725 7.36607 11.7857 8.42679 11.7857 9.72321C11.7857 11.0196 10.725 12.0804 9.42854 12.0804Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42855 14.85C7.23346 14.85 5.12676 15.7634 3.62409 17.3692L3.22632 17.7964L4.08078 18.6067L4.47855 18.1794C5.77498 16.7946 7.5281 16.0285 9.42855 16.0285C11.329 16.0285 13.0821 16.7946 14.3786 18.1794L14.7763 18.6067L15.6308 17.7964L15.233 17.3692C13.7303 15.7781 11.6236 14.85 9.42855 14.85Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2902 7.0567V8.23527C15.675 8.23527 16.9567 8.79509 17.9143 9.81161L18.7687 9.00134C17.6196 7.76384 15.9844 7.0567 14.2902 7.0567Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.104 2.94641C17.104 1.39953 15.837 0.132568 14.2902 0.132568C12.7433 0.132568 11.4763 1.39953 11.4763 2.94641C11.4763 4.49328 12.7433 5.76025 14.2902 5.76025C15.837 5.76025 17.104 4.49328 17.104 2.94641ZM12.6549 2.94641C12.6549 2.04775 13.3915 1.31114 14.2902 1.31114C15.1888 1.31114 15.9254 2.04775 15.9254 2.94641C15.9254 3.84507 15.1888 4.58168 14.2902 4.58168C13.3915 4.58168 12.6549 3.84507 12.6549 2.94641Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56695 7.0567C2.87275 7.0567 1.23749 7.76384 0.0883789 9.00134L0.942843 9.81161C1.8857 8.79509 3.18213 8.23527 4.56695 8.23527V7.0567Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38073 2.94641C7.38073 1.39953 6.11377 0.132568 4.56689 0.132568C3.02002 0.132568 1.75305 1.39953 1.75305 2.94641C1.75305 4.49328 3.02002 5.76025 4.56689 5.76025C6.11377 5.76025 7.38073 4.49328 7.38073 2.94641ZM4.56689 4.58168C3.66823 4.58168 2.93162 3.84507 2.93162 2.94641C2.93162 2.04775 3.66823 1.31114 4.56689 1.31114C5.46555 1.31114 6.20216 2.04775 6.20216 2.94641C6.20216 3.84507 5.46555 4.58168 4.56689 4.58168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.3efb8cef5404f7d9c07c299b9e8d6ff7.svg";
export { ForwardRef as ReactComponent };